"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (contracts) {
    return {
        amountPerPoint: contracts[0].amount_per_point,
        stopType: contracts[0].stop_type,
        stopLoss: contracts[0].stop_loss,
        stopProfit: contracts[0].stop_profit
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/trade/extractSpreadInfo.js
// module id = 612
// module chunks = 0